import { getCoverOrientation, orientation } from '../redux/helpers';

export function calculateStyle(texture, ratio) {
  const {
    left,
    top,
    width,
    height,
  } = texture;
  return {
    left: Math.round(left * ratio),
    top: Math.round(top * ratio),
    width: Math.round(width * ratio),
    height: Math.round(height * ratio),
    position: 'absolute',
    display: 'inline-block',
  };
}

export function calculateBorderStyle(texture, ratio, borderRatio) {
  const {
    width,
    height,
    left,
    top,
  } = texture;


  const newObj = {};

  return Object.assign({
    width: (Math.round(width * ratio) + borderRatio),
    height: (Math.round(height * ratio) + borderRatio),
    position: 'absolute',
    display: 'inline-block',
    left: ((Math.round(left * ratio) - (borderRatio / 2))),
    top: ((Math.round(top * ratio) - (borderRatio / 2))),
    backgroundColor: 'white',
    boxShadow: `0px 0px ${borderRatio / 2}px ${borderRatio / 2}px rgba(0, 0, 0, 0.2)`,
  }, newObj);
}

export function calculcatePlaceholderStyle(texture, ratio) {
  const {
    left,
    top,
  } = texture;
  return {
    left: left * ratio,
    top: top * ratio,
  };
}



// WEBPACK FOOTER //
// ./src/helpers/canvasHelpers.js